<div class="analytics-container">
  <!-- Filter Toolbar -->
  <div class="filter-toolbar">
    <div class="filter-content">
      <!-- Row 1: Scope + Export -->
      <div class="filter-row-1">
        <div class="scope-section">
          <label class="filter-label">Scope</label>
          <div class="scope-controls">
            <kt-hierarchical-filters
              [role]="role"
              [showDistributor]="role === 'sadmin'"
              [showMarket]="role === 'sadmin' || role === 'distiadmin'"
              [showClient]="role === 'sadmin' || role === 'distiadmin' || role === 'marketadmin'"
              [showCampus]="role === 'sadmin' || role === 'distiadmin' || role === 'marketadmin' || role === 'clientadmin'"
              [showMachine]="true"
              [multiple]="true"
              (filterChange)="onHierarchicalFiltersChange($event)">
            </kt-hierarchical-filters>
          </div>
        </div>

        <div class="spacer"></div>

        <!-- Export button -->
        <button 
          type="button" 
          class="export-btn" 
          (click)="onExport()"
          [disabled]="isExportDisabled">
          <mat-icon>file_download</mat-icon>
          Export
        </button>
      </div>

      <!-- Row 2: Breakdown, Product/Drink, Average, Compare, Range -->
      <div class="filter-row-2" [class.filter-row-2--drink-volume]="activeTab === 'drink-volume'">
        <!-- Breakdown by -->
        <div *ngIf="showBreakdown" class="filter-control-group filter-control-group--breakdown">
          <label class="filter-label">Breakdown by</label>
          <kt-segmented-control
            [options]="breakdownOptions"
            [value]="filters.breakdownBy"
            (valueChange)="setBreakdownBy($event)">
          </kt-segmented-control>
        </div>

        <div *ngIf="showSaleScope" class="filter-control-group filter-control-group--sale-scope">
          <label class="filter-label">Sales Scope</label>
          <kt-segmented-control
            [options]="saleScopeOptions"
            [value]="filters.saleScope"
            (valueChange)="setSaleScope($event)">
          </kt-segmented-control>
        </div>

        <!-- Product Select -->
        <div *ngIf="showProduct" class="filter-control-group filter-control-group--product">
          <label class="filter-label">Product / Category</label>
          <kt-searchable-select
            [options]="productOptions"
            placeholder="All Products"
            searchPlaceholder="Search products..."
            [ngModel]="filters.products"
            (selectionChange)="onProductSelectionChange($event)"
            [multiple]="true">
          </kt-searchable-select>
        </div>

        <!-- Drink Select -->
        <div *ngIf="showDrink" class="filter-control-group filter-control-group--drink">
          <label class="filter-label">Drink</label>
          <kt-searchable-select
            [options]="drinkOptions"
            placeholder="All Drinks"
            searchPlaceholder="Search drinks..."
            [ngModel]="filters.drinks"
            (selectionChange)="onDrinkSelectionChange($event)"
            [multiple]="true">
          </kt-searchable-select>
        </div>

        <!-- Average Control -->
        <div *ngIf="showAverageControls" class="filter-control-group filter-control-group--average">
          <label class="filter-label">Average</label>
          <kt-segmented-control
            [options]="averageOptions"
            [value]="averageValue"
            (valueChange)="setAverage($event)">
          </kt-segmented-control>
        </div>

        <!-- Compare Control -->
        <div *ngIf="showAverageControls" class="filter-control-group filter-control-group--compare">
          <label class="filter-label">Compare</label>
          <div class="toggle-control">
            <mat-slide-toggle
              [(ngModel)]="filters.compareEnabled"
              (change)="onCompareToggleChange()"
              color="primary">
            </mat-slide-toggle>
            <span class="toggle-label">Enable</span>
          </div>
        </div>

        <!-- Range/Date Preset -->
        <div *ngIf="showTimePreset" class="filter-control-group filter-control-group--range">
          <label class="filter-label">Range</label>
          <kt-segmented-control
            [options]="datePresetOptions"
            [value]="filters.datePreset"
            (valueChange)="setDatePreset($event)">
          </kt-segmented-control>
        </div>

        <!-- Custom Date Range Pickers -->
        <div *ngIf="showTimePreset && filters.datePreset === 'custom'" class="filter-control-group date-range-pickers">
          <div class="date-picker-wrapper">
            <label class="filter-label">Start Date</label>
            <mat-form-field appearance="outline" class="date-picker-field">
              <input
                matInput
                [(ngModel)]="startDate"
                [matDatepicker]="startPicker"
                [max]="maxStartDate"
                (dateChange)="onStartDateChange($event)"
                readonly>
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="date-picker-wrapper">
            <label class="filter-label">End Date</label>
            <mat-form-field appearance="outline" class="date-picker-field">
              <input
                matInput
                [(ngModel)]="endDate"
                [matDatepicker]="endPicker"
                [min]="minEndDate"
                [max]="maxEndDate"
                (dateChange)="onEndDateChange($event)"
                readonly>
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Forecast Range -->
        <div *ngIf="showForecastRange" class="filter-control-group">
          <label class="filter-label">Forecast</label>
          <kt-segmented-control
            [options]="forecastOptions"
            [value]="forecastDays"
            (valueChange)="setForecastDays($event)">
          </kt-segmented-control>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <nav class="tabs-nav">
      <a
        class="tab-link"
        [class.active]="activeTab === 'drink-volume'"
        (click)="setActiveTab('drink-volume')"
        href="javascript:;">
        Drink Volume
      </a>
      <a
        class="tab-link"
        [class.active]="activeTab === 'consumption'"
        (click)="setActiveTab('consumption')"
        href="javascript:;">
        Consumption
      </a>
      <a
        class="tab-link"
        [class.active]="activeTab === 'forecast'"
        (click)="setActiveTab('forecast')"
        href="javascript:;">
        Forecast
      </a>
      <a
        class="tab-link"
        [class.active]="activeTab === 'stockouts'"
        (click)="setActiveTab('stockouts')"
        href="javascript:;">
        Stock-outs
      </a>
    </nav>
  </div>

  <!-- Content Panels -->
  <main class="analytics-content">
    <!-- Drink Volume Tab -->
    <kt-drink-volume-tab
      *ngIf="activeTab === 'drink-volume'"
      [filters]="filters"
      [drinkOptions]="drinkOptions"
      [productOptions]="productOptions"
      [distributorOptions]="distributorOptions"
      [marketOptions]="marketOptions"
      [clientOptions]="clientOptions"
      [campusOptions]="campusOptions"
      [machineOptions]="machineOptions">
    </kt-drink-volume-tab>

    <!-- Consumption Tab -->
    <kt-consumption-tab
      *ngIf="activeTab === 'consumption'"
      [filters]="filters"
      [drinkOptions]="drinkOptions"
      [productOptions]="productOptions"
      [distributorOptions]="distributorOptions"
      [marketOptions]="marketOptions"
      [clientOptions]="clientOptions"
      [campusOptions]="campusOptions"
      [machineOptions]="machineOptions">
    </kt-consumption-tab>

    <!-- Forecast Tab -->
    <kt-forecast-tab
      *ngIf="activeTab === 'forecast'"
      [filters]="filters"
      [forecastDays]="forecastDays"
      [drinkOptions]="drinkOptions"
      [productOptions]="productOptions"
      [distributorOptions]="distributorOptions"
      [marketOptions]="marketOptions"
      [clientOptions]="clientOptions"
      [campusOptions]="campusOptions"
      [machineOptions]="machineOptions">
    </kt-forecast-tab>

    <!-- Stock-outs Tab -->
    <kt-stockouts-tab
      *ngIf="activeTab === 'stockouts'"
      [filters]="filters"
      [drinkOptions]="drinkOptions"
      [productOptions]="productOptions"
      [distributorOptions]="distributorOptions"
      [marketOptions]="marketOptions"
      [clientOptions]="clientOptions"
      [campusOptions]="campusOptions"
      [machineOptions]="machineOptions"
      (machineFilterChange)="onMachineFilterChange($event)">
    </kt-stockouts-tab>
  </main>
</div>
